<template>
	<b-overlay :show="LoaderStatus" rounded="sm" style="height: 90%">
		<div class="addeval-content-container">
			<!-- Add Name -->
			<b-row
				><b-col>
					<div class="topDiv mt-3 relativeclass add-topic-parent">
						<label class="fieldsetStyle"
							>Evaluator Name &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							v-on:keyup.enter="addEval()"
							class="inputField"
							id="input-1"
							type="text"
							v-model.trim="$v.eval.name.$model"
							placeholder="Enter Name"
							:class="{ error: $v.eval.name.$error }"
						>
						</b-form-input>
						<!-- Validations for Name -->
						<div
							class="ad-eval-validationicon"
							v-if="$v.eval.name.$dirty && !$v.eval.name.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="ad-eval-validationicon"
							v-if="!$v.eval.name.alpha && $v.eval.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Please Enter a Valid Name',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="ad-eval-validationicon"
							v-if="!$v.eval.name.maxLength && $v.eval.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 128 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Add Mail -->
			<b-row
				><b-col>
					<div class="topDiv mt-3 relativeclass add-topic-parent">
						<label class="fieldsetStyle"
							>Email Id &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							class="inputField"
							id="input-1"
							type="email"
							placeholder="Enter Email Id"
							@keyup="convertToLowerCase"
							v-on:keyup.enter="addEval()"
							v-model.trim="$v.eval.email.$model"
							:class="{ error: $v.eval.email.$error }"
						></b-form-input>
						<!-- Validations for Mail -->
						<div
							class="ad-eval-validationicon"
							v-if="$v.eval.email.$dirty && !$v.eval.email.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="ad-eval-validationicon"
							v-if="!$v.eval.email.maxLength"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not execed 320 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="ad-eval-validationicon"
							v-if="!$v.eval.email.localPartMaxLength"
							v-b-popover.hover.top.v-danger="{
								content:
									'Email should not exceed 64 characters before @ symbol',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="ad-eval-validationicon"
							v-if="
								!$v.eval.email.alpha ||
									($v.eval.email.required && !$v.eval.email.email)
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Email is invalid',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Add Contact Number -->
			<b-row
				><b-col>
					<div class="topDiv mt-3 relativeclass add-topic-parent">
						<label class="fieldsetStyle"
							>Contact Number &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							class="inputField"
							id="input-1"
							type="tel"
							@keydown="restrictToNumbers"
							placeholder="Enter Contact Number"
							v-model.trim="$v.eval.phoneNumber.$model"
							v-on:keyup.enter="addEval()"
							:class="{ error: $v.eval.phoneNumber.$error }"
							maxlength="10"
						></b-form-input>
						<!-- Validations for Contact Number -->
						<div
							class="ad-eval-validationicon"
							v-if="$v.eval.phoneNumber.$dirty && !$v.eval.phoneNumber.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>

						<div
							class="ad-eval-validationicon"
							v-if="!$v.eval.phoneNumber.alpha && $v.eval.phoneNumber.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Invalid Number',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="ad-eval-validationicon"
							v-if="
								!$v.eval.phoneNumber.minLength &&
									!$v.eval.phoneNumber.maxLength &&
									$v.eval.phoneNumber.required
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Should contain 10 digits',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Add Area of Expertise Tags -->
			<b-row>
				<b-col>
					<div
						class="topDiv mt-3"
						ref="exp"
						@click="expertiseFunction()"
						v-closable="{
							exclude: ['exp', 'expdropdown'],
							handler: 'hideexpertiseoptions',
						}"
					>
						<label class="fieldsetStyle"
							>Area Of Expertise&nbsp;<span class="asterik">*</span></label
						>
						<b-form-tags
							@input="expertiseFunction()"
							class="inputField"
							:class="{
								tagsinputField:
									$v.aoeoptiontags.length > 0 && !$v.aoeoptiontags.$error,
								error: $v.aoeoptiontags.$error,
								reqd_add_1: $v.aoeoptiontags.$error,
								reqd_add_2: !$v.aoeoptiontags.$error,
							}"
							:tag-validator="tagValidatoraoe"
							invalid-tag-text="Duplicate tag(s)"
							placeholder="Enter Area of Expertise"
							v-model="$v.aoeoptiontags.$model"
							remove-on-delete
						></b-form-tags>
						<!-- Validations for Area of Expertise -->
						<div
							style="position: absolute; right: 12px; top: 2px"
							v-if="$v.aoeoptiontags.$dirty && !$v.aoeoptiontags.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
					<!-- Dropdown for Area of Expertise Tags-->
					<div v-if="aoe == true" class="qb-filter-modal2" ref="expdropdown">
						<div class="relativeclass aoeinput">
							<div class="aoesearchicon-pos">
								<img
									src="../../assets/icons/accesscontrol/inputsearch.svg"
									alt=""
								/>
							</div>
							<b-form-input
								class="inputField"
								type="text"
								placeholder="Search"
								v-model="searchexp"
							>
							</b-form-input>

							<div class="evaluatorDropdown-adjustment-class">
								<b-form-group v-if="searchexpres.length > 0">
									<b-form-checkbox
										class="qb-dropdown-option-sing pointer"
										size="sm"
										v-for="option in searchexpres"
										:key="option.expertise"
										:value="option.expertise"
										v-model="aoeoptiontags"
										name="flavour-4a"
									>
										{{ option.expertise }}
									</b-form-checkbox>
								</b-form-group>

								<div
									v-else-if="searchexpres.length == 0 && searchexp.length > 0"
									class="mt-2 d-flex align-items-center justify-content-center text-break"
									size="sm"
								>
									No matching results found for "{{ searchexp }}"
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Add Skill Tags -->
			<b-row>
				<b-col>
					<div
						class="topDiv mt-3"
						ref="skl"
						@click="skillFunction()"
						v-closable="{
							exclude: ['skl', 'skldropdown'],
							handler: 'hideskillOptions',
						}"
					>
						<label class="fieldsetStyle"
							>Skills&nbsp;<span class="asterik">*</span></label
						>
						<b-form-tags
							@input="skillFunction()"
							:tag-validator="tagValidator"
							class="inputField"
							:class="{
								tagsinputField:
									$v.skilloptionstag.length > 0 && !$v.skilloptionstag.$error,
								error: $v.skilloptionstag.$error,
								reqd_add_1: $v.skilloptionstag.$error,
								reqd_add_2: !$v.skilloptionstag.$error,
							}"
							invalid-tag-text="Duplicate tag(s)"
							placeholder="Enter Skills"
							v-model="$v.skilloptionstag.$model"
							remove-on-delete
						></b-form-tags>
						<!-- Validations for Skills -->
						<div
							style="position: absolute; right: 12px; top: 2px"
							v-if="$v.skilloptionstag.$dirty && !$v.skilloptionstag.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
					<!-- Dropdown for Skill Tags-->
					<div
						v-if="skilltag == true"
						class="qb-filter-modal2"
						ref="skldropdown"
					>
						<div class="relativeclass aoeinput">
							<div class="aoesearchicon-pos">
								<img
									src="../../assets/icons/accesscontrol/inputsearch.svg"
									alt=""
								/>
							</div>
							<b-form-input
								class="inputField"
								type="text"
								placeholder="Search"
								v-model="searchskl"
							>
							</b-form-input>

							<div class="evaluatorDropdown-adjustment-class">
								<b-form-group v-if="searchsklres.length > 0">
									<b-form-checkbox
										class="qb-dropdown-option-sing pointer"
										size="sm"
										v-for="option in searchsklres"
										:key="option.skill"
										name="flavour-4a"
										:value="option.skill"
										v-model="skilloptionstag"
									>
										{{ option.skill }}
									</b-form-checkbox>
								</b-form-group>
								<div
									v-else-if="searchsklres.length == 0 && searchskl.length > 0"
									class="mt-2 d-flex align-items-center justify-content-center text-break"
									size="sm"
								>
									No matching results found for "{{ searchskl }}"
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>

			<div class="twobtns d-flex align-items-center pointer">
				<div class="mr-3 cancelbtntext" @click="$emit('onAddEvaluator')">
					Cancel
				</div>
				<b-button class="addbtn pl-4 pr-4" @click="addEval"> Add </b-button>
			</div>
		</div>
	</b-overlay>
</template>

<script>
import toast from "../../views/mixin/toast";
import {
	searchExp,
	searchSkl,
	addEditEvaluator,
} from "../../controllers/evaluators/asynchronous";
import { getValidations } from "../../controllers/evaluators/validations";
import {
	restrictToNumbers,
	expertiseFunction,
	tagValidator,
	tagValidatoraoe,
	hideexpertiseoptions,
	skillFunction,
	hideskillOptions,
} from "../../controllers/evaluators/helpers";
export default {
	name: "AddEvaluator",
	mixins: [toast],
	data() {
		return {
			searchexp: "",
			searchskl: "",
			firstload: true,
			searchexpres: [],
			searchsklres: [],
			aoetags: {
				expertise: [],
			},
			skillstags: {
				skill: [],
			},
			searchskill: "",
			SearchExpertise: "",
			LoaderStatus: false,
			aoe: false,
			skilltag: false,
			eval: {
				aoearray: [],
				evalID: "",
				skillarray: [],
				name: "",
				email: "",
				phoneNumber: "",
				regex: /^[6-9]\d{9}$/,
			},
			aoeoptiontags: [],
			skilloptionstag: [],
			phoneValid: true,
		};
	},
	validations() {
		return getValidations();
	},
	watch: {
		searchexp: function(newQ, oldQ) {
			if (newQ != oldQ) {
				searchExp(this);
			}
		},
		searchskl: function(newQ, oldQ) {
			if (newQ != oldQ) {
				searchSkl(this);
			}
		},
	},
	created() {
		searchExp(this);
		searchSkl(this);
	},
	methods: {
		restrictToNumbers(evt) {
			restrictToNumbers(evt, this);
		},
		tagValidator(tag) {
			return tagValidator(tag, this);
		},
		tagValidatoraoe(tag) {
			return tagValidatoraoe(tag, this);
		},

		// Define a method that converts the email address to lowercase
		convertToLowerCase() {
			// Use the built-in toLowerCase() method to convert the email to lowercase
			// and store the result back in the object's eval.email property
			this.eval.email = this.eval.email.toLowerCase();
		},
		async addEval() {
			addEditEvaluator("add", this);
		},
		clearevaldata() {
			this.eval = {
				aoearray: [],
				evalID: "",
				skillarray: [],
				name: "",
				email: "",
				phoneNumber: "",
			};
		},
		expertiseFunction() {
			expertiseFunction(this);
		},
		skillFunction() {
			skillFunction(this);
		},
		hideskillOptions() {
			hideskillOptions(this);
		},
		hideexpertiseoptions() {
			hideexpertiseoptions(this);
		},
	},
};
</script>
<style>
.addeval-content-container .b-form-tags input::placeholder {
	font-size: var(--size-13) !important;
	font-weight: var(--weight-R) !important;
	color: #6d6d6d !important;
	opacity: unset;
}
.addeval-content-container .form-control.error:focus {
	font-size: 12px !important;
}

.reqd_add_1 .b-form-tags-list .btn {
	margin-right: 25px;
}

.reqd_add_2 .b-form-tags-list .btn {
	margin-right: 0px;
}

.twobtns {
	position: absolute;
	bottom: 10px;
	right: 20px;
}
.align-items-baseline {
	align-items: self-start !important;
}

.b-form-tag > button.b-form-tag-remove {
	color: inherit;
	font-size: 180%;
	position: relative;
	top: 3px;
	margin-left: 1rem;
}

.close {
	opacity: unset;
}

.offerletter-container {
	background: #ffffff;
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 140px);
	padding: 15px;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
}

.badge {
	padding: 0.1em 1em;
	line-height: 2;
}

.badge-secondary {
	color: #72737e;
	font-size: 12px;
	font-weight: 400;
	background-color: #e7e8f5;
}

.aoeinput .form-control {
	padding: 0.375rem 1.3rem !important;
}

.qb-dropdown-diffy {
	background: #ffffff;
	border: 1px solid #ced4da;
	box-sizing: border-box;
	border-radius: 3px;
	color: #959494;
	font-size: var(--size-13);
	padding: 12px;
}

.qb-dropdown-option-sing:nth-child(even) {
	background: #fdfdfd;
	padding: 10px 30px;
}

.qb-dropdown-option-sing:nth-child(odd) {
	background: #f4f4f4;
	padding: 10px 30px;
}

.templatecards-heading {
	font-weight: 600;
	font-size: 14px;
	color: #72738e;
	padding: 15px;
}

.aoesearchicon-pos {
	position: absolute;
	top: 7px;
	left: 5px;
}

.ad-eval-validationicon {
	position: absolute;
	top: 3px;
	right: 12px;
	background: var(--bg-white);
}

.text-muted {
	color: #dc3545 !important;
}

.duplicate_tag .text-muted {
	color: #dc3545 !important;
}
</style>
